import type { InvoiceDraft } from "@invoicing-sdk/domain";
import type { InvoiceDraftDTO } from "../commands.js";

/**
 * Mapper utility to convert InvoiceDraft domain entity to DTO
 * Preserves DDD boundaries by not exposing domain methods
 */
export class InvoiceDraftMapper {
  /**
   * Converts InvoiceDraft domain entity to InvoiceDraftDTO
   * @param draft - The domain InvoiceDraft entity
   * @returns InvoiceDraftDTO suitable for presentation layer
   */
  static toDTO(draft: InvoiceDraft): InvoiceDraftDTO {
    return {
      invoiceId: draft.invoiceId,
      invoiceNumber: draft.invoiceNumber,
      orderId: draft.orderId,
      customerSnapshot: {
        firstName: draft.customerSnapshot.firstName,
        lastName: draft.customerSnapshot.lastName,
        street: draft.customerSnapshot.street,
        zip: draft.customerSnapshot.zip,
        city: draft.customerSnapshot.city,
        country: draft.customerSnapshot.country,
        email: draft.customerSnapshot.email,
        phone: draft.customerSnapshot.phone,
      },
      itemsSnapshot: draft.itemsSnapshot.map((item) => ({
        name: item.name,
        variant: item.variant,
        productNumber: item.productNumber,
        unitPrice: item.unitPrice.toPlainObject(),
        quantity: item.quantity,
        linePrice: item.linePrice.toPlainObject(),
      })),
      financials: {
        subtotal: draft.financials.subtotal.toPlainObject(),
        taxes: draft.financials.taxes.toPlainObject(),
        shippingCost: draft.financials.shippingCost.toPlainObject(),
        discount: draft.financials.discount.toPlainObject(),
        grandTotal: draft.financials.grandTotal.toPlainObject(),
      },
      status: "DRAFT" as const,
      createdOn: draft.createdOn.toISOString(),
      createdBy: draft.createdBy,
    };
  }
}